<template>
  <div>
    <b-overlay :show="isLoadingData" rounded="sm">
      <b-tabs justified vertical pills small fill>
        <b-tab title="QUESTIONNAIRES">
          <div class="p-3">
            <QuestionnairesComponent :questionnairesData="questionnairesAndCommunicationsData" />
          </div>
        </b-tab>
        <b-tab title="POLICIES">
          <div class="p-3">
            <PoliciesComponent :policiesData="questionnairesAndCommunicationsData" />
          </div>
        </b-tab>
        <b-tab title="TRAINING">
          <div class="p-3">
            <TrainingComponent :trainingData="questionnairesAndCommunicationsData" />
          </div>
        </b-tab>
        <b-tab title="COMMS">
          <div class="p-3">
            <CommsComponent :commsData="questionnairesAndCommunicationsData" />
          </div>
        </b-tab>
      </b-tabs>
    </b-overlay>
  </div>
</template>
<script>
import { HTTP } from "../../../utils/HTTP";
import QuestionnairesComponent from "./questionnairesComponent.vue";
import PoliciesComponent from "./policiesComponent.vue";
import TrainingComponent from "./trainingComponent.vue";
import CommsComponent from "./commsComponent.vue";
export default {
  name: "QuestionnairesPoliciesTrainingTabComponent",
  data() {
    return {
      isLoadingData: false,
      questionnairesAndCommunicationsData: []
    };
  },
  components: {
    QuestionnairesComponent,
    PoliciesComponent,
    TrainingComponent,
    CommsComponent
  },
  mounted() {
    this.getTpQuestionnairesAndCommunications();
  },
  methods: {
    async getTpQuestionnairesAndCommunications() {
      this.questionnairesAndCommunicationsData = [];
      let formData = {
        thirdPartyId: this.$route.params.thirdPartyId,
        companyId: this.$route.params.companyId
      };
      try {
        let token = "Bearer " + localStorage.getItem("accessToken");
        this.isLoadingData = true;
        let result = await HTTP(
          "post",
          "thirdparty/questionnairescommunications",
          formData,
          {
            Authorization: token
          }
        );
        // console.log("result", result);
        if (result && result.data.status == 1 && result.status == 200) {
          this.questionnairesAndCommunicationsData = result.data.response;
          this.isLoadingData = false;
          this.$store.state.questionnairesPoliciesTrainingTTabLazyLoad = false;
        } else {
          this.questionnairesAndCommunicationsData = [];
          this.isLoadingData = false;
          this.$store.state.questionnairesPoliciesTrainingTTabLazyLoad = false;
        }
      } catch (error) {
        this.isLoadingData = false;
      }
    }
  }
};
</script>